export const USE_CASE_ARTWORK = {
  "ad-to-lander": { workflow: "build-landing-page" },
  "paid-social-funnel": { workflow: "build-sales-funnel" },
  "competitor-teardown": { workflow: "research-competitor-ads" },
  "figma-to-page": { workflow: "import-figma" },
  "bundle-builder": { workflow: "build-bundle" },
  "quiz-funnel": { workflow: "build-sales-funnel" },
  "winback-machine": { workflow: "build-landing-page" },
  "sale-launcher": { workflow: "build-storefront" },
  "seasonal-promo": { workflow: "build-storefront" },
  "campaign-pages": { workflow: "shopify-build-ad-page" },
  "slide-out-cart": { workflow: "build-product-page" },
  "page-multiplier": { workflow: "copy-page" },
  "brand-personas": { workflow: "research-competitor-ads" },
  "page-audit": { workflow: "copy-competitor-page" },
  "pixel-audit": { workflow: "connect-domain" },
  "launch-checklist": { workflow: "publish-page" },
  "discount-leak-audit": { workflow: "build-product-page" },
  "ad-split-test": { workflow: "build-sales-funnel" },
  "review-carousel": { workflow: "build-product-page" },
  "case-studies-section": { workflow: "copy-page" },
  "csv-pages": { workflow: "copy-page" },
  "creator-pages": { workflow: "shopify-build-ad-page" },
  "city-pages": { workflow: "connect-domain" },
  "retail-partner-pages": { workflow: "build-storefront" },
  "comparison-pages": { workflow: "copy-competitor-page" },
  "gsc-keyword-lift": { workflow: "publish-page" },
  "programmatic-seo": { workflow: "copy-page" },
  "monday-report": { workflow: "research-competitor-ads" },
  "competitor-watch": { workflow: "research-competitor-ads" },
  "review-digest": { workflow: "research-competitor-ads" },
  "ad-congruence-check": { workflow: "shopify-build-ad-page" },
  "site-upkeep": { workflow: "publish-page" },
  "business-website": { workflow: "services-build-site" },
  "booking-page": { workflow: "services-build-booking-page" },
  "services-pricing-page": { workflow: "services-build-services-page" },
  "offer-landing-page": { workflow: "services-build-landing-page" },
  "saas-landing-page": { workflow: "saas-build-landing-page" },
  "saas-feature-page": { workflow: "saas-build-feature-page" },
  "saas-pricing-page": { workflow: "saas-build-pricing-page" },
  "store-from-scratch": { workflow: "build-storefront" },
} as const;

export type UseCaseArtworkId = keyof typeof USE_CASE_ARTWORK;

export function isUseCaseArtworkId(slug: string): slug is UseCaseArtworkId {
  return Object.hasOwn(USE_CASE_ARTWORK, slug);
}
